export enum ProductSortingEnum {
    BestMatch = "BestMatch",
    ProductNameAz = "ProductNameAz",
    ProductNameZa = "ProductNameZa",
    DateCreated = "DateCreated",
    DateCreatedReverse = "DateCreatedReverse",
}
